import { ref } from 'vue'
import firebase from '../../firebase'
import { collection, query, onSnapshot, orderBy, limit } from 'firebase/firestore'

const getMostUsedTags = () => {
  const mostUsedsessionTags = ref(new Set())

  const loadTags = () => {
    try {
      const tagsRef = collection(firebase.db, 'sessionTags')
      const q = query(tagsRef, orderBy('sessionsCount', 'desc'), limit(5))

      const unsubscribe = onSnapshot(q, (querySnapshot) => {
        // Clear the set before adding new values
        mostUsedsessionTags.value.clear()

        querySnapshot.forEach((doc) => {
          mostUsedsessionTags.value.add(doc.id)
        })
      }, (error) => {
        console.log(error)
      })

      // Clean up the listener when it's no longer needed
      return unsubscribe
    } catch (error) {
      console.log(error)
    }
  }

  return { mostUsedsessionTags, loadTags }
}

export default getMostUsedTags
